import React from 'react';
import { Form } from 'antd';
import cn from 'classnames';
import styles from './FormItem.module.scss';

const { Item } = Form;

const FormItem = ({ label, colon = false, className, inline = false, ...props }) => {
  return (
    <Item
      {...props}
      colon={colon}
      label={label}
      className={cn(styles.root, className, {
        [styles.inline]: inline,
      })}
    />
  );
};

export default FormItem;
